/**
 * @link https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight#common_weight_name_mapping
 */
const fontWeightNames = [
    'thin', 'extraLight', 'light', 'normal', 'medium', 'semiBold', 'bold', 'extraBold', 'black', 'extraBlack',
] as const;

/**
 * All available font-weight by the specification
 */
export type FontWeight = typeof fontWeightNames[number];

/**
 * Font-weight using on the R1 projects
 */
export const r1FontWeights: Record<FontWeight, number> = {
    // [constant name]: our weight, // common weight
    'thin':          400, // 100
    'extraLight':    400, // 200
    'light':         400, // 300
    'normal':        400, // 400
    'medium':        500, // 500
    'semiBold':      600, // 600
    'bold':          600, // 700
    'extraBold':     600, // 800
    'black':         600, // 900
    'extraBlack':    600, // 950
} as const;

/**
 * Helper for getting actual font-weight by the font weight name
 * @param fontWeightName
 */
export const getFontWeightByName = (fontWeightName: FontWeight) => {
    return r1FontWeights[fontWeightName];
};
